import { Carfax } from '../components/inventory/carfax.vue';
Vue.component('carfax', Carfax);